/**
 * The look of time pressure, shared by the queue rows, the Not submitted rows and
 * the tiles: amber when due soon, red when overdue. Always paired with words, so
 * the colour is never the only signal.
 */
export const URGENCY_STYLE = {
  due_soon: { bar: '#d97706', bg: '#fffbeb', text: '#b45309' },
  overdue: { bar: '#dc2626', bg: '#fef2f2', text: '#b91c1c' },
} as const;

export type TUrgency = keyof typeof URGENCY_STYLE;

/** A 4px bar on the row's left edge, and a light tint when overdue. */
export const urgencyRowSx = (urgency: TUrgency | null) =>
  urgency
    ? {
        boxShadow: `inset 4px 0 0 ${URGENCY_STYLE[urgency].bar}`,
        bgcolor: urgency === 'overdue' ? URGENCY_STYLE.overdue.bg : undefined,
      }
    : {};
